// helpers
import { getActionURLWithPLPFilters } from 'shared/layouts/Listing/helpers';

export const getUrl = (img: Listing.IBannerImage) => {
  const url = getActionURLWithPLPFilters(img, 'banner_link');

  return `${url}${url.indexOf('?') > -1 ? '&' : '?'}intcmp=PLP_BANNER`;
};
